module.exports = __webpack_public_path__ + "img/sec3.a65a88ed.jpg";